// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2dCXp","label":"LabeledBox_label__gUT7I"};